import React, { useEffect, useState } from 'react'
// Components
import Link from '@/components/atoms/Link'
import FooterNav from '@/components/organisms/footer-nav'
// Images
import Vespa from '@/images/footer-vespa.png'
import roundel from '@/images/roundel.png'
import instagram from '@/images/social/instagram.svg'
import youtube from '@/images/social/youtube.svg'
import linkedin from '@/images/social/linkedin.svg'
import facebook from '@/images/social/facebook.svg'
import twitter from '@/images/social/x.svg'

const SocialIcon = (props) => (
  <div>
    <img
      src={props.src}
      alt={props.alt}
      sx={{
        width: 30,
        bg: 'white',
        '&:hover': {
          bg: 'contiYellow',
        },
      }}
    />
  </div>
)

const Footer = () => {
  const [osanoReady, setOsanoReady] = useState(false)

  useEffect(() => {
    // Wait for Osano to be available
    const checkOsano = () => {
      if (
        typeof window !== 'undefined' &&
        window.Osano &&
        window.Osano.cm &&
        typeof window.Osano.cm.showDoNotSell === 'function'
      ) {
        setOsanoReady(true)
        return true
      }
      return false
    }

    // Check immediately
    if (checkOsano()) {
      return
    }

    // If not ready, poll for it
    const interval = setInterval(() => {
      if (checkOsano()) {
        clearInterval(interval)
      }
    }, 100)

    // Cleanup after 10 seconds
    const timeout = setTimeout(() => {
      clearInterval(interval)
    }, 10000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [])

  const handleDoNotSellClick = (e) => {
    e.preventDefault()
    // console.log('🔍 Do Not Sell link clicked')

    if (typeof window === 'undefined') {
      // console.error('❌ window is undefined')
      return
    }

    const showDoNotSell = () => {
      try {
        if (
          window.Osano &&
          window.Osano.cm &&
          typeof window.Osano.cm.showDoNotSell === 'function'
        ) {
          // console.log('✅ Calling window.Osano.cm.showDoNotSell()')
          const result = window.Osano.cm.showDoNotSell()
          // console.log('✅ showDoNotSell() returned:', result)

          // Check for Osano elements after a delay
          setTimeout(() => {
            const osanoElements = document.querySelectorAll('[class*="osano"], [id*="osano"]')
            // console.log('🔍 Found Osano DOM elements after call:', osanoElements.length)
            if (osanoElements.length === 0) {
              // console.warn(
              //   '⚠️  No Osano elements found - popup may not be rendering. Check Osano configuration.'
              // )
            }
          }, 500)

          return true
        } else {
          // console.error('❌ Osano not available')
        }
      } catch (error) {
        // console.error('❌ Error calling showDoNotSell:', error)
      }
      return false
    }

    // Try immediately
    if (!showDoNotSell()) {
      // console.log('🔄 Osano not ready, retrying...')
      // Retry with delays
      const retries = [100, 300, 500, 1000]
      retries.forEach((delay) => {
        setTimeout(() => {
          showDoNotSell()
        }, delay)
      })
    }
  }

  const handleCookiePreferencesClick = (e) => {
    e.preventDefault()

    if (typeof window === 'undefined') {
      return
    }

    const showCookiePreferences = () => {
      try {
        if (window.Osano && window.Osano.cm && typeof window.Osano.cm.showDrawer === 'function') {
          window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')
          return true
        }
      } catch (error) {
        // console.error('❌ Error calling showDrawer:', error)
      }
      return false
    }

    // Try immediately
    if (!showCookiePreferences()) {
      // Retry with delays
      const retries = [100, 300, 500, 1000]
      retries.forEach((delay) => {
        setTimeout(() => {
          showCookiePreferences()
        }, delay)
      })
    }
  }

  return (
    <footer
      sx={{
        mx: 'auto',
        backgroundColor: '#111',
        color: '#fff',
        padding: 4,

        flexShrink: '0',
        position: 'relative',
        // height: 300,
      }}
    >
      <FooterNav />

      <div
        sx={{
          maxWidth: [280, 'col6'],
          mx: 'auto',
          mb: [120, 120, 0],
          display: 'flex',
          flexDirection: ['row'],
          flexWrap: 'wrap',
          gap: [3],
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Link
          href="https://www.facebook.com/ModSquadInc/"
          target="_blank"
          variant="styles.a.socialLink"
          context="footer-lower"
        >
          <SocialIcon src={facebook} alt="Facebook" />
        </Link>
        <Link
          href="https://x.com/modsquad"
          target="_blank"
          context="footer-lower"
          variant="styles.a.socialLink"
        >
          <SocialIcon src={twitter} alt="Twitter" />
        </Link>
        <Link
          href="https://instagram.com/modsquad"
          target="_blank"
          context="footer-lower"
          variant="styles.a.socialLink"
        >
          <SocialIcon src={instagram} alt="Instagram" />
        </Link>
        <Link
          href="https://www.linkedin.com/company/modsquad-inc-"
          target="_blank"
          context="footer-lower"
          variant="styles.a.socialLink"
        >
          <SocialIcon src={linkedin} alt="Linkedin" />
        </Link>
        <Link
          href="https://www.youtube.com/user/MetaverseModSquad"
          target="_blank"
          context="footer-lower"
          variant="styles.a.socialLink"
        >
          <SocialIcon src={youtube} alt="YouTube" />
        </Link>
      </div>

      <div
        sx={{
          position: ['static', 'absolute'],
          mx: ['auto', 0],
          textAlign: 'left',
          bottom: 32,
          left: 32,
        }}
      >
        <div
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <img src={roundel} alt="ModSquad Roundel" width="40" />
          <p
            sx={{
              fontSize: 12,
              fontFamily: 'sans',
              fontWeight: '100',
              color: 'white',
            }}
          >
            <Link
              to="/privacy-and-cookies"
              context="footer-lower"
              variant="styles.a.thinWhite"
              sx={{ textTransform: 'uppercase' }}
            >
              Privacy and Cookies
            </Link>
            <br />
            <a
              href="#"
              onClick={handleDoNotSellClick}
              style={{
                color: 'white',
                textDecoration: 'none',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#FCB134' // contiYellow
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'white'
              }}
            >
              Do Not Sell or Share My Personal Information
            </a>
            <br />
            <a
              href="#"
              onClick={handleCookiePreferencesClick}
              style={{
                color: 'white',
                textDecoration: 'none',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#FCB134' // contiYellow
              }}
              onMouseLeave={(e) => {
                e.target.style.color = 'white'
              }}
            >
              Cookie Preferences
            </a>
            <br />©{new Date().getFullYear()} ModSquad, Inc
          </p>
        </div>
      </div>

      <img
        sx={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          height: [140, 200],
        }}
        src={Vespa}
        alt="Scooter"
      />
    </footer>
  )
}

export default Footer
